define.alias("shared/components/shared/color-picker", "media/components/shared/color-picker");